var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 16,
    viewBox: "0 0 60 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35319 5.89154C1.45199 5.34812 1.92528 4.95312 2.47761 4.95312H12.3449C13.0579 4.95312 13.5969 5.59889 13.4693 6.30042L12.3611 12.3957C12.2623 12.9391 11.789 13.3341 11.2367 13.3341H1.36938C0.656351 13.3341 0.117412 12.6883 0.244963 11.9868L1.35319 5.89154Z",
    fill: "#AE7FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63834 3.60541C3.73715 3.06199 4.21044 2.66699 4.76277 2.66699H14.6301C15.3431 2.66699 15.882 3.31276 15.7545 4.01429L14.6463 10.1095C14.5475 10.6529 14.0742 11.0479 13.5218 11.0479H3.65454C2.94151 11.0479 2.40257 10.4022 2.53012 9.70065L3.63834 3.60541Z",
    fill: "#AE7FFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1404_59282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 14,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35319 5.89154C1.45199 5.34812 1.92528 4.95312 2.47761 4.95312H12.3449C13.0579 4.95312 13.5969 5.59889 13.4693 6.30042L12.3611 12.3957C12.2623 12.9391 11.789 13.3341 11.2367 13.3341H1.36938C0.656351 13.3341 0.117412 12.6883 0.244963 11.9868L1.35319 5.89154Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1404_59282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.52344,
    y: 11.0479,
    width: 3.04762,
    height: 0.761905,
    rx: 0.380952,
    fill: "#CCB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.14286H13.9524V6H1V7.14286Z",
    fill: "#CCB6FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4921 2L57.6591 13.544H56.1121L57.9451 2H59.4921ZM55.6571 2.169H57.1781L55.4231 13.232H53.9021L54.8641 7.135H53.5251L53.7591 5.705H55.0981L55.6571 2.169ZM52.6671 7.239C52.8404 7.239 52.9747 7.33433 53.0701 7.525L54.1751 9.813L52.8751 10.84L51.7441 8.383C51.7094 8.331 51.6704 8.305 51.6271 8.305C51.5837 8.305 51.5404 8.331 51.4971 8.383C51.0377 9.11967 50.3487 10.008 49.4301 11.048L48.4551 10.034C49.3737 9.02867 50.0584 8.11 50.5091 7.278C50.9597 6.43733 51.2631 5.54033 51.4191 4.587V4.561H49.6641L49.8981 3.105H54.8381L54.6171 4.561H52.9401V4.574C52.7754 5.614 52.4634 6.58467 52.0041 7.486L52.0561 7.538L52.2901 7.382C52.4374 7.28667 52.5631 7.239 52.6671 7.239Z",
    fill: "#7950EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3043 8.487L38.6543 7.187C39.651 6.84033 40.4353 6.50667 41.0073 6.186C41.5793 5.86533 41.9953 5.54467 42.2553 5.224C42.5153 4.90333 42.68 4.54367 42.7493 4.145L42.7753 3.95H39.5383L39.7723 2.494H44.6343L44.4913 3.391H46.7143L46.9353 2H48.5473L47.5983 7.993H45.9863L46.1163 7.174H43.7763L43.9973 5.796H46.3243L46.4933 4.769H44.2183C44.0363 5.32367 43.7546 5.809 43.3733 6.225C43.0006 6.641 42.485 7.031 41.8263 7.395C41.1763 7.75033 40.3356 8.11433 39.3043 8.487ZM47.0653 12.738L46.8573 14.09H40.5783C39.8936 14.09 39.6076 13.7217 39.7203 12.985L40.0843 10.71H45.5573L45.6873 9.917H40.1623L40.3703 8.591H47.5073L46.9743 11.945H41.5013L41.3713 12.738H47.0653Z",
    fill: "#7950EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9211 10.8528L37.6871 12.3088H27.7031L27.9371 10.8528H32.1101L32.3571 9.31878H29.5361L30.1731 5.30178H35.8021L35.9841 4.11878H30.3551L30.5761 2.67578H37.8431L37.2061 6.67978H31.6031L31.4081 7.87578H37.2711L37.0501 9.31878H33.9821L33.7351 10.8528H37.9211Z",
    fill: "#7950EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.491 7.642H26.879L25.943 13.544H24.331L26.151 2H27.776L27.113 6.186H28.712L28.491 7.642ZM22.966 2.78H24.539L23.317 10.554H18L19.235 2.78H20.808L20.405 5.328H22.563L22.966 2.78ZM22.342 6.771H20.171L19.807 9.111H21.965L22.342 6.771Z",
    fill: "#7950EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_59282",
    x1: -5.91471,
    y1: 9.1436,
    x2: 2.07861,
    y2: 20.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8358FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_59282",
    x1: -3.62956,
    y1: 6.85747,
    x2: 4.36377,
    y2: 18.1398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8358FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectPayment);
export default __webpack_public_path__ + "static/media/direct-payment.68ef52543aba443df9f0a27ef7e2410e.svg";
export { ForwardRef as ReactComponent };